import logo from "../../../img/datashaper.png";
import logoSmall from "../../../img/datashaper_logo.png";
import { Layout, Image } from "antd";
import styles from "./SidebarLayout.module.css";
import SidebarMenu from "./components/Menu";
import { useState } from "react";
import { Link } from "react-router-dom";
import {ROUTES} from "../../../config/consts/routes";

const { Sider } = Layout;

const Sidebar = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return (
    <Sider
      breakpoint="lg"
      // collapsedWidth="0"
      collapsible
      onBreakpoint={(broken) => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        setSidebarCollapsed(collapsed);
      }}
      width={"256px"}
      style={{
        backgroundColor: "var(--primary-dark",
        height: "100vh",
      }}
    >
      {!sidebarCollapsed ? (
        <div className={styles.logo}>
          <Link to={ROUTES.general.main.route}>
            <Image
              style={{ height: "30px" }}
              className={styles.textLogoWhite}
              preview={false}
              src={logo}
            />
          </Link>
        </div>
      ) : (
        <div className={styles.logoSmall}>
          <Link to={ROUTES.general.main.route}>
            <Image
              style={{ height: "30px" }}
              className={styles.textLogoWhite}
              preview={false}
              src={logoSmall}
            />
          </Link>
        </div>
      )}

      <SidebarMenu sidebarCollapsed={sidebarCollapsed} />
    </Sider>
  );
};

export default Sidebar;
